import React from 'react';
import {Route, Redirect} from 'react-router-dom';
// import {} from

const AdminRoute=({component: Component,...rest})=>{
    let authuser = sessionStorage.getItem('Key_Veriable')
    return(<Route
            {...rest}
                render ={(props)=>
                authuser==='ADMIN'? (<Component {...props} />) :(<Redirect to ='/signin'/>)}/> )
};
export default AdminRoute